import { Button, DialogContent, Stack, Typography } from "@mui/material";
import CloseIconButton from "@entrilia/shared/components/CloseIconButton";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import CancelDialogIcon from "@entrilia/shared/icons/CancelDialogIcon";
import type { ReportInfo } from "../../../../../../api/types/svTypes.ts";

interface Props {
  reports: ReportInfo[];
  onOkay: () => void;
  onCancel: () => void;
}

export default function CancelPromptDialog({ reports, onOkay, onCancel }: Props) {
  return (
    <SmallDialog open={true} hideBackdrop onClose={onCancel}>
      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between", px: 3, py: 2 }}>
        <Typography variant="h6" sx={{ fontFamily: "Roboto" }}>
          Stop Copying
        </Typography>
        <CloseIconButton onClick={onCancel} />
      </Stack>
      <DialogContent>
        <Stack sx={{ gap: 1.5, px: 2, alignItems: "center", textAlign: "center" }}>
          <CancelDialogIcon sx={{ width: 80, height: 80 }} />
          <Typography variant="h6" sx={{ fontFamily: "Roboto" }}>
            Stop copying report{reports.length > 1 ? "s" : ""}?
          </Typography>
          <Typography color="textSecondary">
            The copying process will halt for all companies that have not yet copied this report
          </Typography>
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={onCancel}>
        <Button variant="outlined" color="error" onClick={onOkay}>
          Stop Copying
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
}
